define('home/views/ChannelGroupTabCollectionView',[  // eslint-disable-line requirejs/amd-function-arity
    'underscore',
    'backbone-marionette',
    'handlebars',

    'home/views/ChannelGroupCardView',
    'home/templates/channelGroupTabCollection',

    // imported for side effects
    'jquery.slick',
], function (
    _,
    Marionette,
    Handlebars,

    ChannelGroupCardView,
    channelGroupTabCollectionTemplate
) {
    'use strict';

    /**
     * A collection of Channel Group views, shown as slides in a
     * carousel, and used as tab navigation where each tab id is
     * the id of the Channel Group.
     *
     * Expects a collection of Channels
     */
    var ChannelGroupTabCollectionView = Marionette.CompositeView.extend({
        className: 'carousel-wrapper',

        templateHelpers: function () {
            return {
                exploreTab: this.exploreTab,
            };
        },
        template: channelGroupTabCollectionTemplate,

        initialize: function (options) {
            options = options || {};
            this.exploreTab = options.exploreTab;
            this.activeTab = options.activeTab;
        },

        itemViewContainer: '[data-role=tabs-container]',
        itemView: ChannelGroupCardView,
        itemViewOptions: function (channelGroup) {
            return {
                exploreTab: this.exploreTab,
                attributes: {
                    'data-action': 'switch-tab',
                    'data-tab': channelGroup.id,
                    'class': 'channel-tab__item',
                },
            };
        },

        /**
         * Returns the index of the currently active tab. Accounts
         * for special first tab, the 'all' tab.
         *
         * @returns {number} The index of the currently active tab.
         */
        getActiveTabIndex: function () {
            // Add 1 to the tab index to account for the special 'all' tab
            // that appears first.
            return 1 + _.findIndex(this.collection.models, _.bind(function (channelGroup) {
                return channelGroup.id === this.activeTab;
            }, this));
        },

        onCompositeCollectionRendered: function () {
            if (!this.children.length)
                return;

            _.defer(_.bind(this.slickify, this));
        },

        /**
         * Applies the slick.js plugin to the itemViewContainer
         */
        slickify: function () {
            this.$(this.itemViewContainer).slick({
                slidesToScroll: 1,
                slidesToShow: 5,
                centerMode: true,
                focusOnSelect: true,
                variableWidth: true,
                initialSlide: this.getActiveTabIndex(),
                prevArrow: Handlebars.partials.carouselArrowLeft(),
                nextArrow: Handlebars.partials.carouselArrowRight(),
            });
        },
    });

    return ChannelGroupTabCollectionView;
});

